import { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import notificationActions from '../actions/notificationActions';
import CustomIcon from '../CustomIcons';
import NotificationDrawer from '../NotificationsDrawer';
import { getActionableNotifications } from '../utilities/common';

import './styles/index.css';

export class NotificationsBadge extends Component {
  componentDidMount() {
    const { fetchUserPreferences, fetchWebNotifications } = this.props;
    fetchWebNotifications();
    fetchUserPreferences();
  }

  openDrawerClick = e => {
    e.preventDefault();
    const { toggleNotificationsDrawer } = this.props;
    toggleNotificationsDrawer();
  };

  render = () => {
    const { notifications, config, show, path, groups } = this.props;
    const filteredNotifications = getActionableNotifications(notifications, groups, true);
    const isCircledDot = !!filteredNotifications.length;
    return (
      <>
        <div
          className="notification-badge-icon"
          onClick={this.openDrawerClick}
          role="button"
          onKeyDown={this.openDrawerClick}
          tabIndex={0}
        >
          <CustomIcon type="notifications" size="24" fill="#FFFFFF" />
          <span className={`${isCircledDot ? 'circled-dot' : ''}`}>{isCircledDot && filteredNotifications.length}</span>
        </div>
        <NotificationDrawer
          labels={config.notificationDrawer.labels}
          config={config}
          show={show}
          path={path}
          groups={groups}
        />
      </>
    );
  };
}

NotificationsBadge.propTypes = {
  labels: PropTypes.instanceOf(Object),
  config: PropTypes.instanceOf(Object).isRequired,
  notifications: PropTypes.instanceOf(Array),
  show: PropTypes.bool,
  toggleNotificationsDrawer: PropTypes.func.isRequired,
  fetchUserPreferences: PropTypes.func.isRequired,
  fetchWebNotifications: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  groups: PropTypes.instanceOf(Object)
};

NotificationsBadge.defaultProps = {
  labels: {
    title: 'Notifications'
  },
  notifications: [],
  show: false,
  groups: []
};

const mapStateToProps = state => ({
  notifications:
    state.alerts.webNotifications && state.alerts.webNotifications.length ? state.alerts.webNotifications : []
});

const mapDispatchToProps = dispatch => ({
  toggleNotificationsDrawer: () => {
    dispatch(notificationActions.toggleNotificationDrawer());
  },
  fetchUserPreferences: () => {
    dispatch(notificationActions.getNotificationPreferences());
  },
  fetchWebNotifications: () => {
    dispatch(notificationActions.getWebNotifications());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsBadge);
